import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import PayrollDeductionFrom from "./PayrollDeductionFrom";

import styles from "../styles/Income.module.css";
import { Breadcrumb, Flex, Space } from "antd";
import { useNavigate } from "react-router-dom";

const PayrollDeductionCreate = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Space direction="vertical" style={{ width: "100%" }} size={24}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/payroll" },
            { title: t("payroll_setting.header"), href: "/configuration/payroll" },
            {
              title: t("deduction.header"),
              href: "/configuration/payroll",
              onClick: (e) => {
                e.preventDefault();
                navigate("/configuration/payroll", { state: { selectedTab: 'deduction' } });
              }
            },
            { title: t("common.create") }
          ]} />
          <h2>{t("common.create")}</h2>
        </Flex>
        <PayrollDeductionFrom {...props} blankForm />
      </Space>
    </MainLayout>
  );
};

export default PayrollDeductionCreate;
